// extracted by mini-css-extract-plugin
module.exports = {"label":"LabelView_label__27qRg"};